module.exports = __webpack_public_path__ + "img/1L8.b38c321d.png";